export const listGender = [
    {
        id: 1,
        name: 'Masculino',
    },{
        id: 2,
        name: 'Femenino',
    }
]

export const listMaritalStatus = [
    {
        id: 1,
        name: 'Soltero/a',
    }, {
        id: 2,
        name: 'Casado/a',
    }, {
        id: 3,
        name: 'Viudo/a'
    }, {
        id: 4,
        name: 'Divorciado/a'
    }, {
        id: 5,
        name: 'Separado/a'
    }, {
        id: 6,
        name: 'Concubino/a'
    }
]

export const listToggle = [
    {
        id: 2,
        name:"SI"
    }, {
        id: 1,
        name: 'NO'
    }
]

export const listPosTaxProfit = [
    {
        id: 1,
        name: 'Inscripto',
    }, {
        id: 2,
        name: 'No inscripto',
    }, 
    // Se requirió quitar la opción ya que no es válida
    // {
    //     id: 3,
    //     name: 'No responsable'
    // }, 
    {
        id: 4,
        name: 'Exento'
    }, {
        id: 5,
        name: 'Monotributista'
    }, {
        id: 6,
        name: 'No gravado'
    }
]

export const listPostFrontIva = [
    {
        id: 1,
        name: 'Consumidor final',
    }, {
        id: 2,
        name: 'Monotributista',
    }, {
        id: 3,
        name: 'Exento',
    }, {
        id: 4,
        name: 'Responsable inscripto',
    }, {
        id: 5,
        name: 'No inscripto'
    }, {
        id: 6,
        name: 'No gravado'
    }
]

export const listIibbCondicion = [
    {
        id: 1,
        name: 'Inscripto',
    },
    {
        id: 2,
        name: 'No inscripto',
    },
    {
        id: 4,
        name: 'Exento',
    },
]

export const listIibbCategory = [
    {
        id: 1,
        name: 'Convenio Multilateral',
    },
    {
        id: 2,
        name: 'Contribuyente directo - Régimen general',
    },
    {
        id: 3,
        name: 'Convenio Multilateral Especial',
    },
    {
        id: 4,
        name: 'No Inscripto',
    },
    {
        id: 5,
        name: 'Contribuyente directo - Régimen simplificado',
    },
]

export const listIncomeTaxSituation = [
    {
        id: 1,
        name: 'Régimen general',
    }, {
        id: 2,
        name: 'Régimen especial',
    }, {
        id: 3,
        name: 'Régimen simplificado',
    }, {
        id: 4,
        name: 'Convenio multilateral',
    }, {
        id: 5,
        name: 'Contribuyente local',
    }, {
        id: 6,
        name: 'Exento',
    },
]

export const listToggleOwns = [
    {
        id: 2,
        name: 'Posee',
    },
    {
        id: 1,
        name: 'No posee',
    },
]

export const listTypeAccount = [
    {
        id: 1,
        name: 'Cuenta corriente Pesos'
    },{
        id: 2,
        name: 'Caja de ahorro Pesos'
    },{
        id: 3,
        name: 'Cuenta corriente Dólares'
    },{
        id: 4,
        name: 'Caja de ahorro Dólares'
    },
]

export const listNationality = [
    { id: 1,   name: 'Argentina' },
    { id: 2,   name: 'Brasil' },
    { id: 3,   name: 'Uruguay' },
    { id: 4,   name: 'Paraguay' },
    { id: 5,   name: 'Afganistán' },
    { id: 6,   name: 'Albania' },
    { id: 7,   name: 'Alemania' },
    { id: 8,   name: 'Andorra' },
    { id: 9,   name: 'Angola' },
    { id: 10,  name: 'Antigua y Barbuda' },
    { id: 11,  name: 'Argelia' },
    { id: 12,  name: 'Armenia' },
    { id: 13,  name: 'Australia' },
    { id: 14,  name: 'Austria' },
    { id: 15,  name: 'Azerbaiyán' },
    { id: 16,  name: 'Bahamas' },
    { id: 17,  name: 'Bangladés' },
    { id: 18,  name: 'Barbados' },
    { id: 19,  name: 'Baréin' },
    { id: 20,  name: 'Bélgica' },
    { id: 21,  name: 'Belice' },
    { id: 22,  name: 'Benín' },
    { id: 23,  name: 'Bielorrusia' },
    { id: 24,  name: 'Birmania' },
    { id: 25,  name: 'Bolivia' },
    { id: 26,  name: 'Bosnia y Herzegovina' },
    { id: 27,  name: 'Botsuana' },
    { id: 28,  name: 'Brunéi' },
    { id: 29,  name: 'Bulgaria' },
    { id: 30,  name: 'Burkina Faso' },
    { id: 31,  name: 'Burundi' },
    { id: 32,  name: 'Bután' },
    { id: 33,  name: 'Cabo Verde' },
    { id: 34,  name: 'Camboya' },
    { id: 35,  name: 'Camerún' },
    { id: 36,  name: 'Canadá' },
    { id: 37,  name: 'Catar' },
    { id: 38,  name: 'República Centroafricana' },
    { id: 39,  name: 'Chad' },
    { id: 40,  name: 'Chile' },
    { id: 41,  name: 'China' },
    { id: 42,  name: 'Chipre' },
    { id: 43,  name: 'Colombia' },
    { id: 44,  name: 'Comoras' },
    { id: 45,  name: 'Congo' },
    { id: 46,  name: 'República Democrática del Congo' },
    { id: 47,  name: 'Corea del Norte' },
    { id: 48,  name: 'Corea del Sur' },
    { id: 49,  name: 'Costa de Marfil' },
    { id: 50,  name: 'Costa Rica' },
    { id: 51,  name: 'Croacia' },
    { id: 52,  name: 'Cuba' },
    { id: 53,  name: 'Dinamarca' },
    { id: 54,  name: 'República Dominicana' },
    { id: 55,  name: 'Dominica' },
    { id: 56,  name: 'Ecuador' },
    { id: 57,  name: 'Egipto' },
    { id: 58,  name: 'El Salvador' },
    { id: 59,  name: 'Emiratos Árabes Unidos' },
    { id: 60,  name: 'Eritrea' },
    { id: 61,  name: 'Eslovaquia' },
    { id: 62,  name: 'Eslovenia' },
    { id: 63,  name: 'España' },
    { id: 64,  name: 'Estados Unidos' },
    { id: 65,  name: 'Estonia' },
    { id: 66,  name: 'Esuatini' },
    { id: 67,  name: 'Etiopía' },
    { id: 68,  name: 'Filipinas' },
    { id: 69,  name: 'Finlandia' },
    { id: 70,  name: 'Fiyi' },
    { id: 71,  name: 'Francia' },
    { id: 72,  name: 'Gabón' },
    { id: 73,  name: 'Gambia' },
    { id: 74,  name: 'Georgia' },
    { id: 75,  name: 'Ghana' },
    { id: 76,  name: 'Granada' },
    { id: 77,  name: 'Grecia' },
    { id: 78,  name: 'Guatemala' },
    { id: 79,  name: 'Guinea' },
    { id: 80,  name: 'Guinea-Bisáu' },
    { id: 81,  name: 'Guinea Ecuatorial' },
    { id: 82,  name: 'Guyana' },
    { id: 83,  name: 'Haití' },
    { id: 84,  name: 'Honduras' },
    { id: 85,  name: 'Hungría' },
    { id: 86,  name: 'India' },
    { id: 87,  name: 'Indonesia' },
    { id: 88,  name: 'Irán' },
    { id: 89,  name: 'Irak' },
    { id: 90,  name: 'Irlanda' },
    { id: 91,  name: 'Islandia' },
    { id: 92,  name: 'Islas Marshall' },
    { id: 93,  name: 'Islas Salomón' },
    { id: 94,  name: 'Israel' },
    { id: 95,  name: 'Italia' },
    { id: 96,  name: 'Jamaica' },
    { id: 97,  name: 'Japón' },
    { id: 98,  name: 'Jordania' },
    { id: 99,  name: 'Kazajistán' },
    { id: 100, name: 'Kenia' },
    { id: 101, name: 'Kirguistán' },
    { id: 102, name: 'Kiribati' },
    { id: 103, name: 'Kosovo' },
    { id: 104, name: 'Kuwait' },
    { id: 105, name: 'Laos' },
    { id: 106, name: 'Lesoto' },
    { id: 107, name: 'Letonia' },
    { id: 108, name: 'Líbano' },
    { id: 109, name: 'Liberia' },
    { id: 110, name: 'Libia' },
    { id: 111, name: 'Liechtenstein' },
    { id: 112, name: 'Lituania' },
    { id: 113, name: 'Luxemburgo' },
    { id: 114, name: 'Macedonia del Norte' },
    { id: 115, name: 'Madagascar' },
    { id: 116, name: 'Malaui' },
    { id: 117, name: 'Malasia' },
    { id: 118, name: 'Maldivas' },
    { id: 119, name: 'Malí' },
    { id: 120, name: 'Malta' },
    { id: 121, name: 'Marruecos' },
    { id: 122, name: 'Mauricio' },
    { id: 123, name: 'Mauritania' },
    { id: 124, name: 'México' },
    { id: 125, name: 'Micronesia' },
    { id: 126, name: 'Moldavia' },
    { id: 127, name: 'Mónaco' },
    { id: 128, name: 'Mongolia' },
    { id: 129, name: 'Montenegro' },
    { id: 130, name: 'Mozambique' },
    { id: 131, name: 'Namibia' },
    { id: 132, name: 'Nauru' },
    { id: 133, name: 'Nepal' },
    { id: 134, name: 'Nicaragua' },
    { id: 135, name: 'Nigeria' },
    { id: 136, name: 'Níger' },
    { id: 137, name: 'Noruega' },
    { id: 138, name: 'Nueva Zelanda' },
    { id: 139, name: 'Omán' },
    { id: 140, name: 'Países Bajos' },
    { id: 141, name: 'Pakistán' },
    { id: 142, name: 'Palaos' },
    { id: 143, name: 'Palestina' },
    { id: 144, name: 'Panamá' },
    { id: 145, name: 'Papúa Nueva Guinea' },
    { id: 146, name: 'Perú' },
    { id: 147, name: 'Polonia' },
    { id: 148, name: 'Portugal' },
    { id: 149, name: 'Ruanda' },
    { id: 150, name: 'Rumanía' },
    { id: 151, name: 'Rusia' },
    { id: 152, name: 'Sahara Occidental' },
    { id: 153, name: 'Samoa' },
    { id: 154, name: 'San Marino' },
    { id: 155, name: 'Santa Lucía' },
    { id: 156, name: 'San Vicente y las Granadinas' },
    { id: 157, name: 'Senegal' },
    { id: 158, name: 'Serbia' },
    { id: 159, name: 'Seychelles' },
    { id: 160, name: 'Sierra Leona' },
    { id: 161, name: 'Singapur' },
    { id: 162, name: 'Siria' },
    { id: 163, name: 'Somalia' },
    { id: 164, name: 'Sri Lanka' },
    { id: 165, name: 'Sudáfrica' },
    { id: 166, name: 'Sudán' },
    { id: 167, name: 'Sudán del Sur' },
    { id: 168, name: 'Suecia' },
    { id: 169, name: 'Suiza' },
    { id: 170, name: 'Surinam' },
    { id: 171, name: 'Tailandia' },
    { id: 172, name: 'Tanzania' },
    { id: 173, name: 'Tayikistán' },
    { id: 174, name: 'Timor Oriental' },
    { id: 175, name: 'Togo' },
    { id: 176, name: 'Tonga' },
    { id: 177, name: 'Trinidad y Tobago' },
    { id: 178, name: 'Túnez' },
    { id: 179, name: 'Turkmenistán' },
    { id: 180, name: 'Turquía' },
    { id: 181, name: 'Tuvalu' },
    { id: 182, name: 'Ucrania' },
    { id: 183, name: 'Uganda' },
    { id: 184, name: 'Uzbekistán' },
    { id: 185, name: 'Vanuatu' },
    { id: 186, name: 'Venezuela' },
    { id: 187, name: 'Vietnam' },
    { id: 188, name: 'Yemen' },
    { id: 189, name: 'Yibuti' },
    { id: 190, name: 'Zambia' },
    { id: 191, name: 'Zimbabue' },
]

export const listProvince = [
    { id: 1,  name: 'Buenos Aires' },
    { id: 2,  name: 'Catamarca' },
    { id: 3,  name: 'Chaco' },
    { id: 4,  name: 'Chubut' },
    { id: 5,  name: 'CABA' },
    { id: 6,  name: 'Córdoba' },
    { id: 7,  name: 'Corrientes' },
    { id: 8,  name: 'Entre Ríos' },
    { id: 9,  name: 'Formosa' },
    { id: 10, name: 'Jujuy' },
    { id: 11, name: 'La Pampa' },
    { id: 12, name: 'La Rioja' },
    { id: 13, name: 'Mendoza' },
    { id: 14, name: 'Misiones' },
    { id: 15, name: 'Neuquén' },
    { id: 16, name: 'Río Negro' },
    { id: 17, name: 'Salta' },
    { id: 18, name: 'San Juan' },
    { id: 19, name: 'San Luis' },
    { id: 20, name: 'Santa Cruz' },
    { id: 21, name: 'Santa Fe' },
    { id: 22, name: 'Santiago del Estero' },
    { id: 23, name: 'Tierra del Fuego' },
    { id: 24, name: 'Tucumán' },
]

export const listActivityType = [
    {
        "id": 0,
        "name": "Seleccionar"
    },
    {
        "id": 2,
        "name": "Agricultura, Ganadería, Caza, Silvicultura y Pesca"
    },
    {
        "id": 10,
        "name": "Fabricación de maquinarias y Equipos (Todas)"
    },
    {
        "id": 11,
        "name": "Fabricación de Vehículos Automotores, Remolques y Semirremolques"
    },
    {
        "id": 13,
        "name": "Electricidad, Gas, Vapor y Agua Caliente"
    },
    {
        "id": 14,
        "name": "Captación, Depuración y Distribución de Agua"
    },
    {
        "id": 15,
        "name": "export Construcción"
    },
    {
        "id": 19,
        "name": "Hotelería y Restaurantes"
    },
    {
        "id": 20,
        "name": "Transporte, Almacenamiento y Comunicaciones"
    },
    {
        "id": 21,
        "name": "Intermediación financiera y/o bursátil y/o cambiario y/o cia de seguros"
    },
    {
        "id": 22,
        "name": "Inmobiliarios, Empresariales y de Alquiler"
    },
    {
        "id": 23,
        "name": "Administración Pública, Defensa y Seguridad Social Obligatoria"
    },
    {
        "id": 24,
        "name": "Enseñanza"
    },
    {
        "id": 28,
        "name": "Oficio/Ocupación"
    },
    {
        "id": 36,
        "name": "NOTARIO"
    },
    {
        "id": 38,
        "name": "Ejecutivo Directivo"
    },
    {
        "id": 43,
        "name": "Jubilado"
    },
    {
        "id": 44,
        "name": "Estudiante"
    },
    {
        "id": 47,
        "name": "Desempleado"
    },
    {
        "id": 55,
        "name": "Otro"
    },
    {
        "id": 80,
        "name": "Profesional Independiente"
    },
    {
        "id": 83,
        "name": "Metalúrgica"
    },
    {
        "id": 86,
        "name": "Locación de Inmuebles"
    },
    {
        "id": 87,
        "name": "Consul General"
    },
    {
        "id": 89,
        "name": "Despachante de Aduana"
    },
    {
        "id": 97,
        "name": "Servicios sociales, asistenciales y previsionales"
    },
    {
        "id": 107,
        "name": "Producción, comercialización y distribución de productos de elecrónica"
    },
    {
        "id": 108,
        "name": "Funcionario Público"
    },
    {
        "id": 113,
        "name": "Servicios Bursátiles"
    },
    {
        "id": 117,
        "name": "Farmacéutica"
    },
    {
        "id": 124,
        "name": "Generación de Energía NCP"
    },
    {
        "id": 131,
        "name": "Producción de Espectaculos Teatrales y Musicales"
    },
    {
        "id": 139,
        "name": "Juez"
    },
    {
        "id": 153,
        "name": "Sociedad de Garantía Recíproca"
    },
    {
        "id": 157,
        "name": "Productor y/o Asesor de Seguros"
    },
    {
        "id": 175,
        "name": "TEXTIL"
    },
    {
        "id": 181,
        "name": "Fondos Comunes de Inversión"
    },
    {
        "id": 185,
        "name": "Industria manufacturera"
    },
    {
        "id": 187,
        "name": "Servicios de Crédito"
    },
    {
        "id": 192,
        "name": "Escribano Público"
    },
    {
        "id": 194,
        "name": "Servicios gastronómicos y hotelería"
    },
    {
        "id": 195,
        "name": "INFORMATICA"
    },
    {
        "id": 203,
        "name": "SERVICIOS DE INFORMATICA"
    },
    {
        "id": 205,
        "name": "GENERACION DE ENERGIA"
    },
    {
        "id": 206,
        "name": "Electrónica"
    },
    {
        "id": 210,
        "name": "Servicios de Asesoramiento"
    },
    {
        "id": 227,
        "name": "RECOLECCION DE DESECHOS NO PELIGROSOS"
    },
    {
        "id": 233,
        "name": "Agente/Corredor  Inmobiliaria matriculado"
    },
    {
        "id": 238,
        "name": "Secretario de Estado Pcia Cordoba"
    },
    {
        "id": 240,
        "name": "PROCESAMIENTO DE DATOS"
    },
    {
        "id": 242,
        "name": "TRADUCTOR/A PUBLICO/A"
    },
    {
        "id": 249,
        "name": "Deportistas profesionales"
    },
    {
        "id": 265,
        "name": "GESTION CULTURAL"
    },
    {
        "id": 271,
        "name": "Rentistas"
    },
    {
        "id": 291,
        "name": "Empleado"
    },
    {
        "id": 294,
        "name": "SERVICIOS DE ASESORAMIENTO Y DIRECCION"
    },
    {
        "id": 307,
        "name": "SERVICIOS EMPRESARIALES"
    },
    {
        "id": 318,
        "name": "MEDICINA PREPAGA"
    },
    {
        "id": 322,
        "name": "RECOLECCION,TRANSPORTE Y SIDPOSICION FIANL DE RESIDUOS"
    },
    {
        "id": 348,
        "name": "SERVICIOS DE ORGANIZACIONES PROFESIONALES"
    },
    {
        "id": 352,
        "name": "GUIA DE TREKKING"
    },
    {
        "id": 353,
        "name": "Contador Público matriculado"
    },
    {
        "id": 357,
        "name": "SERVICIO DE TRANSPORTE AUTOMOTOR DE CARGAS N.C.P"
    },
    {
        "id": 358,
        "name": "ORGANIZADOR DE EVENTOS"
    },
    {
        "id": 363,
        "name": "SERVICIOS DE GESTION ADUANERA"
    },
    {
        "id": 366,
        "name": "INDUSTRIA PETROLERA"
    },
    {
        "id": 367,
        "name": "SEPELIO"
    },
    {
        "id": 368,
        "name": "SERVICIOS DE PUBLICIDAD"
    },
    {
        "id": 369,
        "name": "SERVICIO DE FAENA DE ANIMALES"
    },
    {
        "id": 370,
        "name": "Servicios sociales y de la salud y asociados al riesgo de trabajo"
    },
    {
        "id": 371,
        "name": "SERVICIOS JURIDICOS"
    },
    {
        "id": 372,
        "name": "FUNDACION"
    },
    {
        "id": 373,
        "name": "SERVICIOS AUXILIARES A LOS SERVICIOS DE SEGUROS"
    },
    {
        "id": 374,
        "name": "GESTION DE COBRANZA"
    },
    {
        "id": 377,
        "name": "SERVICIOS DE ENTIDADES DE TARJETA DE CREDITO"
    },
    {
        "id": 378,
        "name": "SERVICIOS INMOBILIARIOS"
    },
    {
        "id": 379,
        "name": "SERVICIOS FINANCIEROS"
    },
    {
        "id": 384,
        "name": "SUMINISTRO DE AGUA POTABLE"
    },
    {
        "id": 385,
        "name": "SERVICIO DE ESTACIONAMIENTO Y GARAGE"
    },
    {
        "id": 387,
        "name": "SERVICIOS DE VIGILANCIA"
    },
    {
        "id": 391,
        "name": "SERVICIOS DE FAST FOOD Y LOCALES DE VENTA DE COMIDAS Y BEBIDAS AL PASO"
    },
    {
        "id": 395,
        "name": "SERVICIOS DE TELECOMUNICACIONES"
    },
    {
        "id": 397,
        "name": "Información, tecnología y comunicaciones"
    },
    {
        "id": 398,
        "name": "SERVICIOS DE ASOCIACIONES"
    },
    {
        "id": 399,
        "name": "SERVICIOS DE BOLSA DE COMERCIO"
    },
    {
        "id": 400,
        "name": "Servicios turísticos"
    },
    {
        "id": 402,
        "name": "SERVICIOS PROFESIONALES, CIENTIFICOS Y TECNICOS"
    },
    {
        "id": 403,
        "name": "Comerciante de rodados, yates, naves, aeronaves"
    },
    {
        "id": 404,
        "name": "Comercio de arte, antigüedades, joyas"
    },
    {
        "id": 406,
        "name": "Fiduciario/intermed./adm. Fideicomiso"
    },
    {
        "id": 407,
        "name": "Persona que explota juegos de azar"
    },
    {
        "id": 408,
        "name": "SERVICIOS DE ENTRETENIMIENTO"
    },
    {
        "id": 412,
        "name": "SERVICIOS DE LIMPIEZA GENERAL DE EDIFICIOS"
    },
    {
        "id": 414,
        "name": "Servicios de Seguros e Intermediacion Financierra"
    },
    {
        "id": 416,
        "name": "SERVICIOS DE SALUD HUMANA"
    },
    {
        "id": 418,
        "name": "SERVICIOS DE COBROS"
    },
    {
        "id": 431,
        "name": "Comercio al por mayor y menor"
    },
    {
        "id": 432,
        "name": "Provisión de servicios públicos (luz, agua, gas, cloacas)"
    },
    {
        "id": 433,
        "name": "Servicios de arrendamiento de bienes muebles (equipos, máquinas, tractores)"
    },
    {
        "id": 434,
        "name": "Servicios de transporte público"
    },
    {
        "id": 435,
        "name": "Servicios artísticos, culturales, deportivos y de esparcimiento"
    },
    {
        "id": 436,
        "name": "Organizaciones No Gubernamentales"
    },
    {
        "id": 437,
        "name": "Asociaciones Gremiales / Sindicales"
    },
    {
        "id": 438,
        "name": "Asociaciones civiles y cooperativas de trabajo (no crediticias)"
    },
    {
        "id": 439,
        "name": "Clubes deportivos"
    },
    {
        "id": 440,
        "name": "Servi de créd n.c.p. (coop de crédito, vivienda y consumo, mutuales, tarj reg)"
    },
    {
        "id": 441,
        "name": "Remesadoras de Fondos"
    },
    {
        "id": 442,
        "name": "Registros Públicos (IGJ, Automotor, Aeronaves, de Comercio, etc)"
    },
    {
        "id": 443,
        "name": "Emisoras y operadoras de cheques de viajero y tarjetas de crédito"
    },
    {
        "id": 444,
        "name": "Transportadoras de Caudales"
    },
    {
        "id": 445,
        "name": "Empresas de servicios postales"
    },
    {
        "id": 446,
        "name": "Entidades religiosas, culto, credo, etc"
    },
    {
        "id": 447,
        "name": "Explotación minera, gas y energía"
    },
    {
        "id": 448,
        "name": "Servicios de reparación de bienes muebles e inmuebles"
    },
    {
        "id": 449,
        "name": "Fideicomisos financieros"
    },
    {
        "id": 450,
        "name": "Fideicomisos no financieros"
    },
    {
        "id": 451,
        "name": "LABORATORIO"
    },
    {
        "id": 452,
        "name": "Holding"
    },
    {
        "id": 453,
        "name": "Servicios de asesoramiento (empresarial, jurídico, contable, etc.)"
    },
    {
        "id": 454,
        "name": "Servicios de logística y transporte de bienes muebles"
    },
    {
        "id": 455,
        "name": "Servicios de arrendamiento de bs inmuebles propios"
    },
    {
        "id": 456,
        "name": "servicio de logistica"
    },
    {
        "id": 457,
        "name": "Previsión Social"
    },
    {
        "id": 458,
        "name": "SGR (Sociedad de Garantía Recíproca)"
    },
    {
        "id": 459,
        "name": "Servicios de Criptomonedas"
    },
    {
        "id": 460,
        "name": "Fabricación y/o comercialización de armas"
    },
    {
        "id": 461,
        "name": "Industria farmacéutica"
    },
    {
        "id": 462,
        "name": "Imprentas, editoriales"
    }
]